import { JSON_TABLE_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const RoleFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [{
                    "type": "text",
                    "name": "name",
                    "label": "Nombre Rol",
                    "isHorizontal": true,
                    "labelSizing": {
                        "sm": 2
                    },
                    "sizing": {
                        "sm": 6
                    },
                    "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                }],
                [{
                    "type": "text",
                    "name": "description",
                    "label": "Description",
                    "isHorizontal": true,
                    "labelSizing": {
                        "sm": 2
                    },
                    "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                }],
            ]
        }
    ],
};


export default RoleFormConfig;